/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveCliente } from "../../../project/services/ClienteService";
import { getTiposDocumentos } from "../../../project/services/TipoDocumentoService";
import { getGeneros } from "../../../project/services/GeneroService";
import { getDepartamentos } from "../../../project/services/DepartamentoService";
import { getProvincias } from "../../../project/services/ProvinciaService";
import { getPaises } from "../../../project/services/PaisService";
import { isPositiveInteger, onlyLettersAndSpaces, isValidEmail, calculateDifferenceYears } from "../../../project/utils/utils";
import { isValid, isBefore } from "date-fns";

import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: "",
  tipoDocumento: "",
  numeroDocumento: "",
  nombre: "",
  apellido: "",
  fechaNacimiento: null,
  edadActual: 0,
  genero: "",
  numeroCuitCuil: "",
  domicilio: "",
  localidad: "",
  departamento: "",
  provincia: "",
  pais: "",
  codigoPostal: "",
  eMail: "",
  telefonoMovil: "",
  telefonoFijo: "",
};

const nameItemText = "Cliente";
const itemGender = "M";
// const elLa = itemGender === "M" ? "el" : "la";
// const unUna = itemGender === "M" ? "un" : "una";
//
// ###########################################################################
//
const ClienteDialog = ({ onSave, onClose, itemCrud, actionCrud, setMessage, setShowMessage }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [paises, setPaises] = useState([]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTiposDocumentos();
    loadGeneros();
    loadDepartamentos();
    loadProvincias();
    loadPaises();
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const loadTiposDocumentos = async () => {
    const response = await getTiposDocumentos();
    if (response.ok) {
      setTiposDocumentos(response.data.data);
    } else {
      setTiposDocumentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadGeneros = async () => {
    const response = await getGeneros();
    if (response.ok) {
      setGeneros(response.data.data);
    } else {
      setGeneros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadDepartamentos = async () => {
    const response = await getDepartamentos();
    if (response.ok) {
      setDepartamentos(response.data.data);
    } else {
      setDepartamentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProvincias = async () => {
    const response = await getProvincias();
    if (response.ok) {
      setProvincias(response.data.data);
    } else {
      setProvincias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadPaises = async () => {
    const response = await getPaises();
    if (response.ok) {
      setPaises(response.data.data);
    } else {
      setPaises([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaNacimiento = (parFechaNacimiento) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      fechaNacimiento: parFechaNacimiento,
      edadActual: calculateDifferenceYears(parFechaNacimiento),
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {

      if (itemCrudLocal.tipoDocumento === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un tipo de documento",
        });
        setShowMessage(true);
        return;
      }

      if (
        !isPositiveInteger(itemCrudLocal.numeroDocumento) ||
        itemCrudLocal.numeroDocumento.length < 7
      ) {
        setMessage({
          severity: "error",
          messageText: "El documento del Cliente debe ser un número de 7 o más dígitos",
        });
        setShowMessage(true);
        return;
      }

      if (
        itemCrudLocal.nombre === "" ||
        itemCrudLocal.nombre.length < 3 ||
        !onlyLettersAndSpaces(itemCrudLocal.nombre)
      ) {
        setMessage({
          severity: "error",
          messageText: "El nombre del Cliente no es válido",
        });
        setShowMessage(true);
        return;
      }

      if (
        itemCrudLocal.apellido === "" ||
        itemCrudLocal.apellido.length < 3 ||
        !onlyLettersAndSpaces(itemCrudLocal.apellido)
      ) {
        setMessage({
          severity: "error",
          messageText: "El apellido del Cliente no es válido",
        });
        setShowMessage(true);
        return;
      }

      if (
        itemCrudLocal.fechaNacimiento === null ||
        !isValid(itemCrudLocal.fechaNacimiento) ||
        isBefore(new Date(), itemCrudLocal.fechaNacimiento) ||
        calculateDifferenceYears(itemCrudLocal.fechaNacimiento) > 120
        // getAge(format(itemCrudLocal.fechaNacimiento, "yyyy-MM-dd HH:mm:ss")) > 120
      ) {
        setMessage({
          severity: "error",
          messageText: "La fecha de nacimiento del Cliente no es válida",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.genero === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el género del Cliente",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.eMail !== "" && !isValidEmail(itemCrudLocal.eMail)) {
        setMessage({
          severity: "error",
          messageText: "El mail del Cliente no es válido",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {
      id_tipo_documento: itemCrudLocal.tipoDocumento,
      num_doc: itemCrudLocal.numeroDocumento,
      numero_cuit_cuil: itemCrudLocal.numeroCuitCuil,
      nombre: itemCrudLocal.nombre,
      apellido: itemCrudLocal.apellido,
      id_genero: itemCrudLocal.genero,
      fecha_nac: format(itemCrudLocal.fechaNacimiento, "yyyy/MM/dd"),
      email: itemCrudLocal.eMail,
      telefono_movil: itemCrudLocal.telefonoMovil,
      telefono: itemCrudLocal.telefonoFijo,
      domicilio: itemCrudLocal.domicilio,
      localidad: itemCrudLocal.localidad,
      id_departamento: itemCrudLocal.departamento || null,
      id_provincia: itemCrudLocal.provincia || null,
      id_pais: itemCrudLocal.pais || null,
      codigo_postal: itemCrudLocal.codigoPostal,
      actividad_list: [],
      otra_actividad: "",
      ocupacion_list: [],
      otra_ocupacion: "",
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveCliente(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {/* tipo de documento */}

              <Grid item xs={12} md={6} lg={6}>

                <FormControl
                  disabled={actionCrud !== "new"}
                  sx={{ mb: 1, width: "100%" }}
                >
                  <InputLabel id="tipo-documento-select-label">Tipo de Documento</InputLabel>
                  <Select
                    labelId="tipo-documento-select-label"
                    id="tipo-documento-select"
                    name="tipoDocumento"
                    value={tiposDocumentos.length > 0 ? itemCrudLocal.tipoDocumento : ""}
                    label="Tipo de documento"
                    size="small"
                    onChange={handleChange}
                  >
                    {tiposDocumentos.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* numero de documento */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="numero-documento"
                  label="Número"
                  variant="outlined"
                  size="small"
                  name="numeroDocumento"
                  value={itemCrudLocal.numeroDocumento}
                  onChange={handleChange}
                  disabled={actionCrud !== "new"}
                />
              </Grid>

              {/* nombre */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="nombre"
                  label="Nombre"
                  variant="outlined"
                  size="small"
                  name="nombre"
                  value={itemCrudLocal.nombre}
                  onChange={handleChange}
                />
              </Grid>

              {/* apellido */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="apellido"
                  label="Apellido"
                  variant="outlined"
                  size="small"
                  name="apellido"
                  value={itemCrudLocal.apellido}
                  onChange={handleChange}
                />
              </Grid>

              {/* fecha de nacimiento */}

              <Grid item xs={12} md={6} lg={6}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  id="fechaNacimiento"
                  label="Fecha de Nacimiento"
                  variant="outlined"
                  name="fechaNacimiento"
                  value={itemCrudLocal.fechaNacimiento}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) => handleChangeFechaNacimiento(newValue)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              {/* edad  */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  id="edad"
                  label="Edad"
                  variant="outlined"
                  size="small"
                  name="edadActual"
                  value={itemCrudLocal.edadActual}
                  onChange={handleChange}
                  disabled={true}
                />
              </Grid>

              {/* genero */}

              <Grid item xs={12} md={6} lg={6}>

                <FormControl sx={{ width: "100%", mb: 1 }}>
                  <InputLabel id="genero-select-label">Género</InputLabel>
                  <Select
                    labelId="genero-select-label"
                    id="genero-select"
                    name="genero"
                    value={generos.length > 0 ? itemCrudLocal.genero : ""}
                    label="Género"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {generos.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* numero de cuit cuil  */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  id="numero-cuit-cuil"
                  label="CUIT/CUIL (sin guiones)"
                  variant="outlined"
                  size="small"
                  name="numeroCuitCuil"
                  value={itemCrudLocal.numeroCuitCuil}
                  onChange={handleChange}
                />
              </Grid>

              {/* domicilio */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="domicilio"
                  label="Domicilio"
                  variant="outlined"
                  size="small"
                  name="domicilio"
                  value={itemCrudLocal.domicilio}
                  onChange={handleChange}
                />
              </Grid>

              {/* localidad  */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="localidad"
                  label="Localidad"
                  variant="outlined"
                  size="small"
                  name="localidad"
                  value={itemCrudLocal.localidad}
                  onChange={handleChange}
                />
              </Grid>

              {/* departamento */}

              <Grid item xs={12} md={6} lg={6}>

                <FormControl sx={{ width: "100%", mb: 1 }}>
                  <InputLabel id="departamento-select-label">Departamento</InputLabel>
                  <Select
                    labelId="departamento-select-label"
                    id="departamento-select"
                    name="departamento"
                    value={departamentos.length > 0 ? itemCrudLocal.departamento : ""}
                    label="Departamento"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {departamentos.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* provincia */}

              <Grid item xs={12} md={6} lg={6}>
                <FormControl sx={{ width: "100%", mb: 1 }}>
                  <InputLabel id="provincia-select-label">Provincia</InputLabel>
                  <Select
                    labelId="provincia-select-label"
                    id="provincia-select"
                    name="provincia"
                    value={provincias.length > 0 ? itemCrudLocal.provincia : ""}
                    label="provincia"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {provincias.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* pais */}

              <Grid item xs={12} md={6} lg={6}>
                <FormControl sx={{ width: "100%", mb: 1 }}>
                  <InputLabel id="pais-select-label">País</InputLabel>
                  <Select
                    labelId="pais-select-label"
                    id="pais-select"
                    name="pais"
                    value={paises.length > 0 ? itemCrudLocal.pais : ""}
                    label="pais"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {paises.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* codigo postal */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoPostal"
                  label="Código Postal"
                  variant="outlined"
                  size="small"
                  name="codigoPostal"
                  value={itemCrudLocal.codigoPostal}
                  onChange={handleChange}
                />
              </Grid>

              {/* email */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="eMail"
                  label="E-Mail"
                  variant="outlined"
                  size="small"
                  name="eMail"
                  value={itemCrudLocal.eMail}
                  onChange={handleChange}
                />
              </Grid>

              {/* telefono movil */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="telefonoMovil"
                  label="Teléfono Móvil"
                  variant="outlined"
                  size="small"
                  name="telefonoMovil"
                  value={itemCrudLocal.telefonoMovil}
                  onChange={handleChange}
                />
              </Grid>

              {/* telefono fijo */}

              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  sx={{ width: "100%", mb: 1 }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="telefonoFijo"
                  label="Teléfono Fijo"
                  variant="outlined"
                  size="small"
                  name="telefonoFijo"
                  value={itemCrudLocal.telefonoFijo}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Button
              sx={{ mr: 1, backgroundColor: "warning" }}
              variant="contained"
              onClick={handleSave}
              startIcon={
                actionCrud === "disable" ? (
                  <RemoveCircleOutlineIcon />
                ) : actionCrud === "enable" ? (
                  <AddCircleOutlineIcon />
                ) : (
                  <SaveIcon />
                )
              }
            >
              {actionCrud === "disable"
                ? "Deshabilitar"
                : actionCrud === "enable"
                  ? "Habilitar"
                  : "Guardar"}
            </Button>
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ClienteDialog;